import React, { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Eye, FileText, FileUp, Loader2 } from "lucide-react";
import { extractErrorMessage } from "@/lib/api";
import { DOC_KINDS, openDoc, uploadPersonnelDoc } from "./PersonnelDocsField";

export const DocsMenu = ({ p, docs, onChanged, testPrefix = "" }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState("");
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return undefined;
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [open]);
  const has = (k) => docs.find((d) => d.kind === k);
  const n = DOC_KINDS.filter((k) => has(k.k)).length;
  const tone = n === 2 ? "text-emerald-600 hover:bg-emerald-50" : n === 1 ? "text-amber-600 hover:bg-amber-50" : "text-slate-300 hover:bg-slate-100 hover:text-slate-500";
  const upload = async (kind, f) => {
    if (!f) return;
    setBusy(kind);
    try { await uploadPersonnelDoc(p.id, kind, f); toast.success(`${p.ad_soyad} · bildirge yüklendi`); onChanged?.(); setOpen(false); }
    catch (e) { toast.error(extractErrorMessage(e, "Yüklenemedi")); } finally { setBusy(""); }
  };

  return (
    <span className="relative inline-block mr-1 align-middle" ref={ref}>
      <button type="button" onClick={() => (n === 1 ? openDoc(docs.find((d) => DOC_KINDS.some((k) => k.k === d.kind))) : setOpen(!open))} data-testid={`${testPrefix}docs-menu-${p.sicil_no}`}
        className={`relative inline-flex items-center justify-center w-8 h-8 rounded-lg transition-colors ${tone}`}
        title={n === 2 ? "SGK bildirgeleri · seçmek için tıklayın" : n === 1 ? `${DOC_KINDS.find((k) => has(k.k)).label} · açmak için tıklayın (diğeri eksik)` : "SGK bildirgesi yok · yüklemek için tıklayın"}>
        <FileText size={14} />
        {n > 0 && <span className="absolute -top-0.5 -right-0.5 text-[8px] font-black bg-white rounded-full px-0.5">{n}</span>}
      </button>
      {open && (
        <div className="absolute right-0 top-9 z-30 w-56 bg-white border border-slate-200 rounded-lg shadow-lg p-1 text-left" data-testid={`${testPrefix}docs-menu-pop-${p.sicil_no}`}>
          {DOC_KINDS.map(({ k, label }) => {
            const d = has(k);
            return d ? (
              <button key={k} type="button" onClick={() => { openDoc(d); setOpen(false); }} data-testid={`${testPrefix}docs-open-${k}-${p.sicil_no}`}
                className="w-full flex items-center gap-2 px-2 py-1.5 rounded text-xs font-semibold text-slate-800 hover:bg-emerald-50">
                <Eye size={13} className="text-emerald-600" />
                <span className="flex-1">{label}<span className="block text-[10px] font-normal text-slate-400 truncate">{d.original_filename}</span></span>
              </button>
            ) : (
              <label key={k} className="w-full flex items-center gap-2 px-2 py-1.5 rounded text-xs font-semibold text-slate-500 hover:bg-slate-50 cursor-pointer">
                {busy === k ? <Loader2 size={13} className="animate-spin" /> : <FileUp size={13} />}
                <span className="flex-1">{label}<span className="block text-[10px] font-normal text-rose-500">yok · yükle</span></span>
                <input type="file" accept=".pdf,.jpg,.jpeg,.png" className="hidden" data-testid={`${testPrefix}docs-upload-${k}-${p.sicil_no}`}
                  onChange={(e) => { upload(k, e.target.files?.[0]); e.target.value = ""; }} />
              </label>
            );
          })}
        </div>
      )}
    </span>
  );
};
